import { GlButton } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
export default {
    name: 'ResolveDiscussionButton',
    components: {
        GlButton
    },
    props: {
        isResolving: {
            type: Boolean,
            required: false,
            default: false
        },
        buttonTitle: {
            type: String,
            required: true
        }
    },
    emits: [
        'on-click'
    ]
};
